<style type="text/css">
.el-table_1_column_7 .cell,
.el-table_1_column_10 .cell {
    text-align: center;
}
.el-select-dropdown__item span,
.el-tag .el-select__tags-text {
    text-transform: capitalize;
}
.el-table_1_column_6 .cell {
    padding-left: 15px !important;
}
.el-table .warning-row,
.el-table table.el-table__body tr.el-table__row.warning-row > td {
    background: oldlace;
}
.report-upload-popup button.el-dialog__headerbtn {
    z-index: 2;
}
.reports-admin-panel .el-table th > .cell {
    word-break: inherit;
}

.reports-admin-panel .el-pager li {
    font-size: 16px;
}

.reports-admin-panel .el-pagination {
    text-align: center;
    padding: 12px 5px 0 5px;
}
</style>
<style scoped>
.content-wrapper .content {
    padding-top: 90px;
    padding-left: 5px;
    padding-right: 5px;
}
.heading-cart {
    position: relative;
    padding-left: 15px;
    padding-right: 15px;
}
.box-header .box-title {
    display: inline-block;
    font-size: 15px;
    padding: 10px;
    line-height: 1;
    color: black;
}
.heading-cart {
    margin-bottom: 0;
}
.box-body {
    padding: 0px 20px 20px;
}
.el-button.edit {
    padding: 5px 10px;
}
.select-input {
    width: 100%;
}
.form-label {
    font-weight: bold;
    text-transform: capitalize;
}
button[disabled='disabled'],
button:disabled {
    background-color: rgba(200, 200, 200, 2.3);
    border-color: rgba(200, 200, 200, 2.3);
    cursor: not-allowed;
}
button.el-button.is-circle {
    border-radius: 50%;
    padding: 4px;
}
.el-dialog__title {
    position: absolute;
    top: 16px;
    left: 0;
    right: 0;
    z-index: 1;
}
a.report-name {
    color: #878d99;
}
div.cell {
    text-align: center;
}
.el-button--success {
    /* color: #fff; */
    background-color: #67c23a !important;
    border-color: #67c23a !important;
}
.el-button--danger {
    background-color: #fa5555 !important;
    border-color: #fa5555 !important;
}

.white-space-pre {
    white-space: pre;
}

.atd-report-download {
    color: #333;
}
</style>
<template>
    <div class="content-wrapper">
        <section class="content">
            <div class="box">
                <div class="box-header with-border heading-cart">
                    <h3 class="box-title">Admin Reports</h3>
                    <!-- <el-button type="success" size="small" icon="el-icon-upload" class="pull-right" round @click='setReport("updated",default_date)'>Upload Report</el-button> -->
                </div>
                <div class="box-body reports-admin-panel">
                    <el-table
                        v-loading="loading"
                        :data="reportStatus"
                        height="655"
                        stripe
                        style="width: 100%; border-spacing: 0"
                        id="assoc-table"
                    >
                        <el-table-column label="Report Date" width="100" fixed="left" class="text-center">
                            <template slot-scope="props">
                                {{ props.row.date }}
                                <!-- </router-link> -->
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-for="(bidder, index) in biddersList"
                            :label="bidder"
                            width="100"
                            class="text-center"
                        >
                            <template slot-scope="props">
                                <div v-if="props.row.data.filter((x) => x['report_name'] == bidder).length > 0">
                                    <div
                                        v-if="props.row.data.filter((x) => x['report_name'] == bidder)[0].is_done"
                                        :class="'text-center index' + index"
                                    >
                                        <el-button
                                            :key="bidder.replace(' ', '_') + '-' + props.row.date"
                                            type="success"
                                            icon="el-icon-check"
                                            :class="'is-circle btn-' + bidder.replace(' ', '_') + '-' + props.row.date"
                                            @click="regenerateReport(bidder, props.row.date, $event)"
                                        ></el-button>
                                    </div>
                                    <div v-else class="text-center">
                                        <el-button
                                            :key="bidder.replace(' ', '_') + '-' + props.row.date"
                                            type="danger"
                                            icon="el-icon-close"
                                            :class="'is-circle btn-' + bidder.replace(' ', '_') + '-' + props.row.date"
                                            @click="regenerateReport(bidder, props.row.date, $event)"
                                        ></el-button>
                                    </div>
                                </div>
                                <div v-else class="text-center">
                                    <el-button
                                        :key="bidder.replace(' ', '_') + '-' + props.row.date"
                                        type="danger"
                                        icon="el-icon-close"
                                        :class="'is-circle btn-' + bidder.replace(' ', '_') + '-' + props.row.date"
                                        @click="regenerateReport(bidder, props.row.date, $event)"
                                    ></el-button>
                                </div>
                                <div
                                    :class="
                                        'text-center white-space-pre atd-text-' +
                                        bidder.replace(' ', '_') +
                                        '-' +
                                        props.row.date
                                    "
                                >
                                    <div v-if="props.row.data.filter((x) => x['report_name'] == bidder).length > 0">
                                        {{
                                            getLastUpdateDate(
                                                props.row.data.filter((x) => x['report_name'] == bidder)[0]
                                            ) | moment('MMM Do YYYY[\n] h:mm:ss a')
                                        }}
                                    </div>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column label="Update Pub Dashboard" width="110" fixed="right">
                            <template slot-scope="props">
                                <div class="text-center">
                                    <el-button
                                        type="primary"
                                        icon="el-icon-refresh"
                                        :class="'is-circle btn-resync text-center'"
                                        @click="confirmReUpload(props.row.date)"
                                    ></el-button>
                                </div>
                            </template>
                        </el-table-column>

                        <!-- <el-table-column label="Switch Adx" width="110" fixed="right">

								<el-switch v-model="adxSwitch"></el-switch>

						</el-table-column> -->

                        <el-table-column label="Download" width="110" fixed="right">
                            <template slot-scope="props">
                                <el-dropdown
                                    trigger="click"
                                    @command="(command) => handleCommand(command, props.row.date)"
                                >
                                    <el-button class="el-dropdown-link" size="mini" round> Download </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item icon="el-icon-plus" command="get_bidder_revenue_report"
                                            >Bidder Report</el-dropdown-item
                                        >
                                        <el-dropdown-item
                                            icon="el-icon-circle-plus"
                                            command="get_dfp_bidder_revenue_report"
                                            >DFP + Bidder Report</el-dropdown-item
                                        >
                                        <el-dropdown-item icon="el-icon-circle-plus-outline" command="get_axt_report"
                                            >AXT Report</el-dropdown-item
                                        >
                                        <el-dropdown-item icon="el-icon-circle-plus-outline" command="get_amp_report"
                                            >AMP Report</el-dropdown-item
                                        >
                                        <el-dropdown-item icon="el-icon-circle-plus-outline" command="get_adserving_fee"
                                            >Adserving Fee Report</el-dropdown-item
                                        >
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column label="Approve Status" width="110" fixed="right">
							<template slot-scope="props">
							<el-button v-if="getReportApprovalStatus(props.row.date)=='Upload'" size="mini" @click='setReport("updated",props.row.date)' round>{{getReportApprovalStatus(props.row.date)}}</el-button>

							<router-link :to="{name:'BidderDfpReport', params: { reportName: `${props.row.date}` }}" class='report-name' v-else-if="getReportApprovalStatus(props.row.date)=='Approved'">
								<el-button size="mini" round type="success">{{getReportApprovalStatus(props.row.date)}}</el-button>
							</router-link>

							<router-link :to="{name:'BidderDfpReport', params: { reportName: `${props.row.date}` }}" class='report-name' v-else>
								<el-button size="mini" round>{{getReportApprovalStatus(props.row.date)}}</el-button>
							</router-link>
							</template>
						</el-table-column> -->
                        <!-- <el-table-column label="Switch Adx" width="110" fixed="right">

								<el-switch v-model="adxSwitch"></el-switch>

						</el-table-column> -->
                    </el-table>
                    <el-dialog
                        :visible.sync="UploadScreenVisible"
                        class="report-upload-popup"
                        :before-close="clearFilesList"
                    >
                        <span class="el-dialog__title text-center"
                            >Upload {{ bidder_name }} report for {{ report_date }}</span
                        >
                        <template v-if="bidder_name == 'mmadx'">
                            <div class="text-center">
                                <span class="m-r-15"><h5 class="dis-inline-block">Report type:</h5></span>
                                <el-select v-model="reportType" placeholder="Select">
                                    <el-option
                                        v-for="item in reportOptions"
                                        :key="item.reportType"
                                        :label="item.label"
                                        :value="item.reportType"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                        </template>
                        <el-upload
                            v-loading="uploading"
                            class="upload-demo m-t-20"
                            drag
                            :limit="1"
                            action="reports/v1/upload/"
                            :auto-upload="false"
                            :http-request="upload"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :file-list="fileList"
                            ref="upload"
                        >
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
                            <div class="el-upload__text" slot="tip" v-if="bidder_name == 'updated'">
                                Upload modified DFP + Bidder Report
                            </div>
                        </el-upload>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="cancelUploadAction">Cancel</el-button>
                            <el-button type="success" @click="submitUpload">Upload Report</el-button>
                        </span>
                    </el-dialog>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        :total="totalPage"
                        :page-size="5"
                    >
                    </el-pagination>
                </div>
            </div>
        </section>
    </div>
</template>
<script type="text/javascript">
import axios from 'axios';
import moment from 'moment';
import PusherJS from 'pusher-js';
export default {
    data() {
        return {
            dfpReportUrl: '',
            adxSwitch: true,
            biddersList: [],
            reportStatus: [],
            report_name_list: [],
            UploadScreenVisible: false,
            report_date: '',
            bidder_name: '',
            frmdata: new FormData(),
            data: { bidder: '', report_date: '' },
            reportOptions: [
                {
                    reportType: 'banner',
                    label: 'Banner Report',
                },
                {
                    reportType: 'video',
                    label: 'Video Report',
                },
            ],
            reportType: 'banner',
            reportStartDate: undefined,
            reportDateArr: [],
            loading: false,
            uploading: false,
            clickedClass: '',
            downloadAllReport: 'el-icon-download',
            ongoingReports: [],
            reportApprovalStatus: [],
            taskRunChannel: undefined,
            reportsCheck: undefined,
            totalPage: 0,
            currentPage: 1,
            pickerOptions1: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
                shortcuts: [
                    {
                        text: 'Today',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        },
                    },
                    {
                        text: 'Yesterday',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        },
                    },
                    {
                        text: '3 days back',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 2);
                            picker.$emit('pick', date);
                        },
                    },
                ],
            },
            default_date: (
                new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 2)).getFullYear() +
                '-' +
                (new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 2)).getMonth() + 1) +
                '-' +
                new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 2)).getDate()
            ).toString(),
            disabledReports: [],
            emailReportBidderList: [],
        };
    },
    created: function () {
        this.loading = true;
        axios.get(BASE_URL + 'reports/v1/available-bidders-list/').then((response) => {
            this.biddersList = response.data.data
                .filter((e) => {
                    return e.disabled == false;
                })
                .map((k) => k.name);
            this.emailReportBidderList = response.data.data
                .filter((e) => {
                    return e.is_email_report == true;
                })
                .map((o) => o.name);
            this.disabledReports = response.data.data
                .filter((e) => {
                    return e.disabled == true;
                })
                .map((o) => o.name);
        });
        // axios.get(BASE_URL+'reports/v1/reports-approval-status/')
        // .then(response=>{this.reportApprovalStatus = response.data})
        axios
            .get(BASE_URL + 'reports/v1/ongoing-reports/')
            .then((response) => {
                this.ongoingReports =
                    response.data.data == null
                        ? []
                        : response.data.data.filter((e) => {
                              return e != '';
                          });

                this.disableOngoingReports(this.ongoingReports);
            })
            .catch((e) => console.log(e));

        this.getReportStatusList(1);
    },
    methods: {
        getReportStatusList(page) {
            axios
                .get(BASE_URL + 'reports/v1/report-status/?page=' + page)
                .then((response) => {
                    // console.log(response.data.data)
                    this.reportStatus = response.data.data;

                    let report_dates_array = [];
                    this.totalPage = response.data.pages;
                    this.currentPage = response.data.page;

                    this.reportStatus.map((k) => {
                        report_dates_array.push(k.date);
                    });
                    if (page == 1) {
                        this.reportStartDate = this.getFirstDateFromReport(report_dates_array);
                        // console.log('data: ',this.reportStartDate)
                        this.reportDateArr = this.getDaysArray(
                            new Date(this.reportStartDate),
                            new Date(this.getTodayDate())
                        );

                        this.reportDateArr.map((e) => {
                            this.checkAndAdd(e, this.reportStatus);
                        });
                        this.reportStatus.sort(function compare(a, b) {
                            let dateA = new Date(a.date);
                            let dateB = new Date(b.date);
                            return dateB - dateA;
                        });
                    }

                    this.pusherStart();

                    this.loading = false;
                    // console.log(this.reportStatus)
                })
                .catch(function (e) {
                    console.log(e);
                });
        },
        handleCurrentChange(val) {
            console.log(`Current page ${val}`);
            this.getReportStatusList(val);
        },
        reportSync(date) {
            this.report_date = date;
            axios
                .post(BASE_URL + 'reports/v1/sync-report-with-dashboard/', { report_date: this.report_date })
                .then((response) => {
                    console.log(response.data);
                    let respData = response.data;
                    this.notificationMsg(respData.status, respData.data.message);
                });
        },
        getLastUpdateDate(obj) {
            return obj.last_update == null ? obj.modified : obj.last_update;
        },
        disableOngoingReports: function (arr) {
            setTimeout(function () {
                if (arr.length > 0) {
                    arr.map((report) => {
                        console.log(report);
                        // console.log(jQuery(report).children('i'))
                        jQuery('.btn-' + report)
                            .children('i')
                            .attr('class', 'el-icon-loading');
                        jQuery('.btn-' + report).attr('disabled', 'true');
                    });
                }
            }, 500);
            // check status every 1.5 seconds
            this.reportsCheck = setInterval((report) => {
                axios
                    .get(BASE_URL + 'reports/v1/ongoing-reports/')
                    .then((response) => {
                        this.ongoingReports =
                            response.data.data == null
                                ? []
                                : response.data.data.filter((e) => {
                                      return e != '';
                                  });

                        if (this.ongoingReports.length == 0) {
                            // if no tasks running, stop checking
                            console.log('all tasks complete');
                            clearInterval(this.reportsCheck);
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        clearInterval(this.reportsCheck);
                    });
                console.log('test:', this.ongoingReports);
            }, 10500);
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        open5() {
            this.$message({
                showClose: true,
                message: 'This is a message.',
            });
        },
        getReport: function (report_date) {
            axios.get(BASE_URL + 'reports/v1/download/' + report_date + '/').then((response) => {
                console.log(response);
            });
        },
        checkAndAdd: function (val, arr) {
            let date = arr.length + 1;
            let found = arr.some(function (el) {
                return el.date === val;
            });
            // return [val,found]
            if (!found) {
                arr.push({ date: val, data: [] });
            }
        },
        getDaysArray: function (start, end) {
            for (var arr = [], dt = start; dt <= end; dt.setDate(dt.getDate() + 1)) {
                let curDate = new Date(dt);
                let dd = curDate.getDate();
                let mm = curDate.getMonth() + 1; //January is 0
                let yyyy = curDate.getFullYear();

                if (dd < 10) {
                    dd = '0' + dd;
                }

                if (mm < 10) {
                    mm = '0' + mm;
                }

                curDate = yyyy + '-' + mm + '-' + dd;
                arr.push(curDate);
            }
            return arr;
        },
        getFirstDateFromReport: function (arr) {
            let minDate = new Date(
                Math.min.apply(
                    null,
                    arr.map(function (e) {
                        return new Date(e);
                    })
                )
            );
            let dd = minDate.getDate();
            let mm = minDate.getMonth() + 1; //January is 0
            let yyyy = minDate.getFullYear();

            if (dd < 10) {
                dd = '0' + dd;
            }

            if (mm < 10) {
                mm = '0' + mm;
            }

            minDate = yyyy + '-' + mm + '-' + dd;
            return minDate;
        },
        getTodayDate: function () {
            let today = new Date();
            let dd = today.getDate();
            let mm = today.getMonth() + 1; //January is 0
            let yyyy = today.getFullYear();

            if (dd < 10) {
                dd = '0' + dd;
            }

            if (mm < 10) {
                mm = '0' + mm;
            }

            today = yyyy + '-' + mm + '-' + dd;
            return today;
        },
        notificationMsg: function (type = 'Error', msg) {
            this.$notify({
                title: type,
                message: msg ? msg : 'Oops Something went wrong!',
                type: type.toLowerCase(),
            });
        },
        cancelUploadAction: function () {
            this.$refs.upload.clearFiles();
            this.UploadScreenVisible = false;
        },
        setReport: function (bidder_name, report_date) {
            this.UploadScreenVisible = true;
            // if(bidder_name == 'updated'){
            // 	this.report_date = this.default_date
            // }else{
            this.report_date = report_date;
            // }
            this.bidder_name = bidder_name;
            console.log(bidder_name);
        },
        setUpdatedReport: function (bidder_name, report_date) {
            this.UploadScreenVisible = true;
            this.report_date = report_date;
            this.bidder_name = bidder_name;
            console.log(bidder_name);
        },
        getDateTime: function (date) {
            let dateTime = date;
            function pad2(n) {
                // always returns a string
                return (n < 10 ? '0' : '') + n;
            }
            //MMM Do YYYY[\n] h:mm:ss a
            return (
                dateTime.getFullYear() +
                '-' +
                pad2(dateTime.getMonth() + 1) +
                '-' +
                pad2(dateTime.getDate()) +
                '<br/>' +
                pad2(dateTime.getHours()) +
                ':' +
                pad2(dateTime.getMinutes()) +
                ':' +
                pad2(dateTime.getSeconds())
            );
        },
        notificationMsg: function (type = type, msg) {
            this.$notify({
                title: type,
                message: msg,
                type: type.toLowerCase(),
            });
        },
        pusherStart: function () {
            var pusher = new PusherJS(
                ...JSON.parse(PUSHER_CREDENTIALS.replace('AUTH_TOKEN_HERE', localStorage.getItem('default_auth_token')))
            );
            this.taskRunChannel = pusher.subscribe('my-channel');
            this.taskRunChannel.bind('reports_task', (data) => {
                // console.log('terre',data)
                jQuery('.btn-' + data.element)
                    .children('i')
                    .attr('class', 'el-icon-loading');
                if (data.type == 'complete') {
                    jQuery('.btn-' + data.element).removeClass('el-button--success');
                    jQuery('.btn-' + data.element).removeClass('el-button--danger');
                    jQuery('.btn-' + data.element).addClass('el-button--success');
                    jQuery('.btn-' + data.element)
                        .children('i')
                        .attr('class', 'el-icon-check');
                    jQuery('.btn-' + data.element).attr('disabled', 'true');
                } else if (data.type == 'failed') {
                    jQuery('.btn-' + data.element).removeClass('el-button--success');
                    jQuery('.btn-' + data.element).removeClass('el-button--danger');
                    jQuery('.btn-' + data.element).addClass('el-button--danger');
                    jQuery('.btn-' + data.element)
                        .children('i')
                        .attr('class', 'el-icon-close');
                    jQuery('.btn-' + data.element).removeAttr('disabled');
                    // this.notificationMsg('Error',data.message)
                } else {
                    jQuery('.btn-' + data.element)
                        .children('i')
                        .attr('class', 'el-icon-loading');
                    jQuery('.btn-' + data.element).attr('disabled', 'true');
                }
                // this.notificationMsg((data.type) ? 'Success' : 'Error', data.message)
            });
        },
        regenerateReport: function (bidder_name, report_date, event) {
            // console.log(this.disabledReports)
            if (this.emailReportBidderList.indexOf(bidder_name) > -1) {
                return this.setReport(bidder_name, report_date);
            }
            // let taskRunChannel = pusher.subscribe('my-channel');
            // console.log(taskRunChannel);
            jQuery('.btn-' + bidder_name + '-' + report_date).attr('disabled', 'true');
            jQuery('.atd-text-' + bidder_name + '-' + report_date).html(
                moment(new Date()).format('MMM Do YYYY[\n] h:mm:ss a')
            );

            // let clan = jQuery(this).attr('class')
            // console.log(clan)
            if (event.target.className == 'el-icon-close' || event.target.className == 'el-icon-check') {
                event.target.className = 'el-icon-loading';
            } else if (
                event.target.className == 'el-button is-circle el-button--success' ||
                event.target.className == 'el-button is-circle el-button--danger'
            ) {
                event.target.firstElementChild.className = 'el-icon-loading';
                // event.target.parentElement.className='el-button is-circle el-button--success'
            }
            // this.taskRunChannel.bind("reports_task", (data) => {
            // // console.log('terre',data)
            // jQuery('.btn-'+data.element).children('i').attr('class','el-icon-loading')
            // if(data.type == 'complete'){
            // 	jQuery('.btn-'+data.element).removeClass('el-button--success')
            // 	jQuery('.btn-'+data.element).removeClass('el-button--danger')
            // 	jQuery('.btn-'+data.element).addClass('el-button--success')
            // 	jQuery('.btn-'+data.element).children('i').attr('class','el-icon-check')
            // 	jQuery('.btn-'+data.element).attr('disabled','true')
            // }
            // else if(data.type == 'failed'){
            // 	jQuery('.btn-'+data.element).removeClass('el-button--success')
            // 	jQuery('.btn-'+data.element).removeClass('el-button--danger')
            // 	jQuery('.btn-'+data.element).addClass('el-button--danger')
            // 	jQuery('.btn-'+data.element).children('i').attr('class','el-icon-close')
            // 	jQuery('.btn-'+data.element).removeAttr('disabled')
            // 	this.notificationMsg('Error',data.message)
            // }
            // else{
            // 	jQuery('.btn-'+data.element).children('i').attr('class','el-icon-loading')
            // 	jQuery('.btn-'+data.element).attr('disabled','true')
            // }
            // // this.notificationMsg((data.type) ? 'Success' : 'Error', data.message)
            // })

            // })

            this.data['bidder'] = bidder_name;
            this.data['report_date'] = report_date;
            this.data['run_time'] = new Date();
            // console.log(this.data)
            axios.post(BASE_URL + 'reports/v1/regenerate/', this.data).then((response) => {
                if (response.data.status == 'Success') {
                    console.log('a func for ' + this.data + ' was called');
                    setTimeout(function () {
                        axios.get(BASE_URL + 'reports/v1/report-status/').then((response) => {
                            // console.log('a')
                            this.reportStatus = response.data.data;
                        });
                    }, 2000);
                } else {
                    console.log('re:');
                }
            });
        },
        upload: function (upload) {
            // this.incrementNum++
            this.frmdata.append('reportFile', upload.file);
        },
        submitUpload: function () {
            this.$refs.upload.submit();
            // this.uploadTrue='start';
            console.log(this.report_date);
            // if(this.bidder_name == 'updated'){
            // 	this.report_date = this.default_date
            // }else{
            this.report_date = this.report_date;
            // }
            this.frmdata.append('report_date', this.report_date);
            this.frmdata.append('bidder', this.bidder_name);
            this.frmdata.append('report_type', this.reportType);
            this.uploading = true;
            axios
                .post(BASE_URL + 'reports/v1/upload/', this.frmdata)
                .then((response) => {
                    this.uploading = false;
                    // console.log(response)
                    this.notificationMsg(response.status ? 'Success' : 'Error', response.data.data.message);
                    if (response.data.status == 'Success') {
                        this.UploadScreenVisible = false;
                        this.$refs.upload.clearFiles();
                        console.log(jQuery('.btn-' + this.bidder_name + '-' + this.report_date));
                        jQuery('.btn-' + this.bidder_name.replace(' ', '_') + '-' + this.report_date).removeClass(
                            'el-button--success'
                        );
                        jQuery('.btn-' + this.bidder_name.replace(' ', '_') + '-' + this.report_date).removeClass(
                            'el-button--danger'
                        );
                        jQuery('.btn-' + this.bidder_name.replace(' ', '_') + '-' + this.report_date).addClass(
                            'el-button--success'
                        );
                        jQuery('.btn-' + this.bidder_name.replace(' ', '_') + '-' + this.report_date)
                            .children('i')
                            .attr('class', 'el-icon-check');
                        jQuery('.btn-' + this.bidder_name.replace(' ', '_') + '-' + this.report_date).attr(
                            'disabled',
                            'true'
                        );
                    } else {
                        this.UploadScreenVisible = false;
                    }
                })
                .catch((e) => {
                    // console.log('test',e.response)
                    this.uploading = false;
                    this.notificationMsg(
                        e.response.data.data.status ? 'Success' : 'Error',
                        e.response.data.data.message
                    );
                    // this.UploadScreenVisible = false
                    jQuery('.btn-' + this.bidder_name.replace(' ', '_') + '-' + this.report_date).removeClass(
                        'el-button--success'
                    );
                    jQuery('.btn-' + this.bidder_name.replace(' ', '_') + '-' + this.report_date).removeClass(
                        'el-button--danger'
                    );
                    jQuery('.btn-' + this.bidder_name.replace(' ', '_') + '-' + this.report_date).addClass(
                        'el-button--danger'
                    );
                    jQuery('.btn-' + this.bidder_name.replace(' ', '_') + '-' + this.report_date)
                        .children('i')
                        .attr('class', 'el-icon-close');
                    // this.uploadTrue='false'
                });
        },
        confirmReUpload(date) {
            this.$confirm(
                'Publisher Dashboard will be updated even if there are incomplete reports for selected date. Continue?',
                'Warning',
                {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning',
                }
            )
                .then(() => {
                    console.log('pass');
                    this.reportSync(date);
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Action cancelled',
                    });
                });
        },
        clearFilesList: function () {
            this.$refs.upload.clearFiles();
            this.UploadScreenVisible = false;
            // clearFiles on click. dialog inside table(unique dialog for each upload button) doesn't work. hence using these functions as workaround.
        },
        getReportApprovalStatus: function (report_date) {
            // console.log("data",report_date)
            let approvalStatus = this.reportApprovalStatus.filter((k) => {
                return k.date == report_date;
            });

            if (approvalStatus.length == 2) {
                return 'Ongoing';
            } else if (approvalStatus.length == 1) {
                // console.log("data",approvalStatus)
                if (approvalStatus[0].approve_status == true) {
                    return 'Approved';
                }
                if (approvalStatus[0].approve_status == false) {
                    return 'Pending';
                }
            } else {
                return 'Upload';
            }
        },
        handleCommand(command, date, event) {
            this.loading = true;
            if (command == 'get_bidder_revenue_report') {
                return this.getBidderDownload(date);
            }
            if (command == 'get_dfp_bidder_revenue_report') {
                return this.getDownload(date);
            }
            if (command == 'get_axt_report') {
                return this.getAXTReport(date);
            }
            if (command == 'get_amp_report') {
                return this.getAMPReport(date);
            }
            if (command == 'get_adserving_fee') {
                return this.getAdservingReportDownload(date);
            }
        },
        getDownload: function (date) {
            axios.get(BASE_URL + 'reports/v1/download/' + date + '/').then((response) => {
                this.dfpReportUrl = response.data.data.data;
                const link = document.createElement('a');
                link.href = this.dfpReportUrl;
                link.setAttribute('download', 'DFP + Bidder Report - ' + date + '.csv');
                document.body.appendChild(link);

                link.click();

                this.loading = false;
            });
        },
        getAdservingReportDownload: function (date) {
            axios.get(BASE_URL + 'reports/v1/ad-serving-fee/' + date + '/').then((response) => {
                if (response.data.data.status == true) {
                    this.dfpReportUrl = response.data.data.data;
                    const link = document.createElement('a');
                    link.href = this.dfpReportUrl;
                    link.setAttribute('download', 'Adserving-fee-' + date + '.csv');
                    document.body.appendChild(link);

                    link.click();
                } else {
                    this.notificationMsg(response.data.status, response.data.data.message);
                }

                this.loading = false;
            });
        },
        getAXTReport: function (date) {
            axios
                .get(BASE_URL + 'reports/v1/get-axt-report/' + date + '', { responseType: 'blob' })
                .then((response) => {
                    // console.log(response)
                    const type = response.headers['content-type'];
                    console.log(type);
                    const url = window.URL.createObjectURL(new Blob([response.data]), { type: type });
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'AXT Report - ' + date + '.csv');
                    document.body.appendChild(link);
                    link.click();

                    this.loading = false;
                });
        },
        getAMPReport: function (date) {
            axios
                .get(BASE_URL + 'reports/v1/get-amp-report/' + date + '', { responseType: 'blob' })
                .then((response) => {
                    // console.log(response)
                    const type = response.headers['content-type'];
                    console.log(type);
                    const url = window.URL.createObjectURL(new Blob([response.data]), { type: type });
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'AMP Report - ' + date + '.csv');
                    document.body.appendChild(link);
                    link.click();

                    this.loading = false;
                });
        },
        getBidderDownload: function (date) {
            axios
                .get(BASE_URL + 'reports/v1/get-bidder-reports/' + date + '/', { responseType: 'blob' })
                .then((response) => {
                    // console.log(response)
                    const type = response.headers['content-type'];
                    console.log(type);
                    const url = window.URL.createObjectURL(new Blob([response.data]), { type: type });
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Bidders Report - ' + date + '.csv');
                    document.body.appendChild(link);
                    link.click();
                    this.loading = false;
                });
        },
    },
};
</script>



// WEBPACK FOOTER //
// ReportsAdmin.vue?206db2aa